import React, { useState } from 'react';

import { Divider, Drawer, Toolbar } from '@mui/material';
import { StyledDrawer } from './components/StyledDrawer';
import { useAppDispatch, useAppSelector } from 'app/store/store';
import { OpenSidebar } from './components/OpenSidebar';
import { PopperSidebar } from './components/PopperSidebar';
import { CollapseSidebar } from './components/CollapseSidebar';
import { setOpen as SetOpenMobile } from 'app/store/reducers/app/main-layouts/left-sidebar';
import { accountProfileApi } from 'app/store/reducers/api/config-manager-cloud-services/store/account-profiles';
import { AccountRead } from 'app/store/reducers/api/config-manager-cloud-services/store/types';

export const AppSidebar = () => {
  const [open, setOpen] = useState(true);
  const dispatch = useAppDispatch();
  const { open: mobileOpen } = useAppSelector(state => state.mainLayouts.leftSidebar);
  const { appBarHeight } = useAppSelector(state => state.mainLayouts.appbar);
  const { data: accountProfile = {} as AccountRead } =
    accountProfileApi.endpoints.getCurrentAccountProfile.useQueryState();

  const handleMobileToggle = () => {
    dispatch(SetOpenMobile(false));
  };

  const handleDrawerToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  if (accountProfile.status === 'BOOTSTRAP') return null;

  const drawer = (
    <>
      <Toolbar sx={{ minHeight: `${appBarHeight}px !important` }} />
      {mobileOpen ? <OpenSidebar /> : open ? <OpenSidebar /> : <PopperSidebar />}

      <Divider />
      <CollapseSidebar open={open} handleDrawerToggle={handleDrawerToggle} />
    </>
  );

  return (
    <>
      <StyledDrawer
        sx={{
          display: { xs: 'none', md: 'block' },
        }}
        variant="permanent"
        open={open}
      >
        {drawer}
      </StyledDrawer>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleMobileToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 200 },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
};
